var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Add_On",
    "data-name": "Add On",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.708,
    height: 67.568,
    viewBox: "0 0 67.708 67.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M33.829,67.568A33.415,33.415,0,0,1,9.9,57.714a33.814,33.814,0,0,1,0-47.86A33.415,33.415,0,0,1,33.829,0a33.415,33.415,0,0,1,23.93,9.854,33.814,33.814,0,0,1,0,47.86A33.415,33.415,0,0,1,33.829,67.568Zm0-61.937A27.865,27.865,0,0,0,13.84,13.8a28.377,28.377,0,0,0,0,39.977,27.865,27.865,0,0,0,19.989,8.164,28.013,28.013,0,0,0,19.989-47.86A27.024,27.024,0,0,0,33.829,5.631Z",
    transform: "translate(0.025)",
    fill: "#02245a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M13.815,39.784A2.66,2.66,0,0,1,11,36.968V8.815A2.66,2.66,0,0,1,13.815,6a2.66,2.66,0,0,1,2.815,2.815V36.968A2.66,2.66,0,0,1,13.815,39.784Z",
    transform: "translate(20.039 10.892)",
    fill: "#02245a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M36.968,16.631H8.815A2.66,2.66,0,0,1,6,13.815,2.66,2.66,0,0,1,8.815,11H36.968a2.66,2.66,0,0,1,2.815,2.815A2.66,2.66,0,0,1,36.968,16.631Z",
    transform: "translate(10.962 19.968)",
    fill: "#02245a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.191cd9aba70aac47781ef88fdc258057.svg";
export { ForwardRef as ReactComponent };